export default {
  pageTitle: "香港華浩國際 - 匯聚全球精選，服務本土商業",
  nav: {
    home: "首頁",
    about: "關於華浩",
    business: "服務範圍",
    advantages: "核心優勢",
    partners: "服務客戶",
    aboutSubmenu: {
      companyIntro: "公司介紹",
      contact: "聯繫我們",
    },
    businessSubmenu: {
      smartProducts: {
        title: "智能產品",
        items: {
          smartWearable: "智能穿戴",
          personalTerminal: "個人終端",
          homeTerminal: "家庭終端",
          smartRobot: "智能機器人",
        },
      },
      electronicProducts: {
        title: "電子產品",
        items: {
          computer: "電腦",
          mobile: "手機",
          pcba: "PCBA",
          ic: "集成電路",
          newMaterial: "新材料",
        },
      },
      softwareProducts: {
        title: "軟件產品",
        items: {
          aiSoftware: "人工智能軟件",
          techService: "技術開發與服務",
        },
      },
    },
  },
  palette: {
    title: "網站調色板",
    presetThemes: "預設主題",
    customColors: "自定義顏色",
    headerColorStart: "頂部導航欄起始顏色",
    headerColorEnd: "頂部導航欄結束顏色",
    gradientStart: "背景漸變起始色",
    gradientEnd: "背景漸變結束色",
    iconGradientStart: "Icon漸變起始色",
    iconGradientEnd: "Icon漸變結束色",
    accent: "強調色",
    accentLight: "淺色強調色",
    preview: "顏色預覽",
    save: "保存配置",
    export: "導出配置",
    reset: "恢復默認",
    saveSuccess: "配色方案已保存！",
    exportSuccess: "配置已導出！",
    resetConfirm: "確定要恢復默認配色方案嗎？",
    resetSuccess: "已恢復默認配色！",
    warning: "警告",
    confirm: "確定",
    cancel: "取消",
    sectionTitleColor: "章節字體顏色",
  },

  hero: {
    slide1: {
      title: "匯聚全球精選 服務本土商業",
      subtitle: "華浩國際，您全方位的產品與供應鏈夥伴。致力於連接全球優質資源，為各行各業提供從基礎原料到智能科技的多元化商品解決方案",
      button: "聯繫我們",
    },
    slide2: {
      title: "安全快捷 準確專業",
      subtitle: "將全球視野與本地化服務深度融合，成為客戶最值得信賴的產品庫和解決方案夥伴",
      button: "了解更多",
    },
    slide3: {
      title: "跨領域 · 綜合性貿易企業",
      subtitle: "從傳統製造到尖端科技，一站式滿足您多樣化的採購需求",
      button: "立即諮詢",
    },
  },
  business: {
    title: "經營範圍",
    subtitle: "專注科技創新領域，推動業務數字化轉型",
    items: [
      {
        icon: "fas fa-brain",
        title: "人工智能軟件",
        description: "提供先進的AI解決方案，助力企業實現智能化升級與數字化轉型",
      },
      {
        icon: "fas fa-robot",
        title: "智能機器人",
        description: "整合尖端機器人技術，為工業自動化與服務場景提供創新方案",
      },
      {
        icon: "fas fa-microchip",
        title: "集成電路",
        description: "供應高品質集成電路產品，支持電子產品製造與研發需求",
      },
      {
        icon: "fas fa-memory",
        title: "電子元器件",
        description: "提供全面的電子元器件選擇，確保產品性能與可靠性",
      },
      {
        icon: "fas fa-code",
        title: "技術開發與服務",
        description: "專業技術團隊提供定制化開發服務，滿足多樣化技術需求",
      },
      {
        icon: "fas fa-atom",
        title: "新材料",
        description: "提供納米材料、超導材料、高分子材料等前沿新型材料，推動產業技術革新",
      },
    ],
  },
  advantages: {
    title: "核心優勢",
    subtitle: "專業、可靠、值得信賴的全球貿易夥伴",
    items: [
      {
        title: "多元化產品矩陣",
        description: "從日常消費到工業支撐，從傳統製造到尖端科技，提供跨行業的豐富產品選擇。一站式滿足您多樣化的採購需求，簡化供應商管理。",
        icon: "fas fa-boxes",
        features: ["跨行業產品選擇", "一站式採購服務", "簡化供應商管理"],
      },
      {
        title: "深度全球採購網絡",
        description: "與世界各地眾多優質工廠及品牌建立穩固的直接合作關係。從源頭把控產品質量與成本，為您帶來最具競爭力的價格。",
        icon: "fas fa-globe-americas",
        features: ["全球工廠直接合作", "源頭品質成本把控", "最具競爭力價格"],
      },
      {
        title: "專業選品與品控",
        description: "團隊具備專業的市場知識，提供選品建議和市場洞察。嚴格的品質控制流程貫穿始終，確保交付的每一件商品都符合預期標準。",
        icon: "fas fa-certificate",
        features: ["專業市場知識與洞察", "嚴格品控流程", "確保產品標準"],
      },
      {
        title: "敏捷定制化服務",
        description: "理解標準方案並非萬能。無論是特殊規格、小批量試單還是聯合品牌開發，都能提供靈活、響應的服務，量身打造最合適的貿易解決方案。",
        icon: "fas fa-cogs",
        features: ["特殊規格定制", "小批量試單支持", "量身定制方案"],
      },
    ],
  },
  about: {
    title: "關於我們",
    subtitle: "深耕全球貿易，打造一站式產品與供應鏈解決方案",
    companyProfile: "企業簡介",
    description1: '華浩國際（香港）有限公司是一家跨領域的綜合性貿易企業，秉承"全球資源，本土服務"的理念，專注於為客戶提供從基礎原料到尖端科技的全方位產品解決方案。',
    description2: "在華浩，貿易不僅僅是商品的買賣，更是信任的傳遞和價值的創造。我們致力於通過嚴謹的品質把控、專業的市場分析及靈活的定制服務，為每一位客戶創造長期而穩定的價值，助力您的業務持續增長。",
    stats: [
      { number: "10+", label: "年行業經驗" },
      { number: "20+", label: "業務領域" },
      { number: "500+", label: "合作客戶" },
      { number: "100%", label: "客戶滿意度" },
    ],
  },

  // 公司信息詳情頁
  companyInfo: {
    headerTag: "ABOUT US",
    title: "關於我們",
    subtitle: "連接世界·成就未來·共創價值",

    stats: [
      { key: "years", icon: "el-icon-trophy", suffix: "%", label: "客戶滿意度", target: 100 },
      { key: "countries", icon: "el-icon-map-location", suffix: "+", label: "國家覆蓋", target: 68 },
      { key: "partners", icon: "el-icon-user", suffix: "+", label: "合作夥伴", target: 500 },
      { key: "volume", icon: "el-icon-data-line", suffix: "千萬", label: "年交易額", target: 2.8 },
    ],
    intro: {
      title: "專業的國際貿易服務商",
      paragraphs: ["　　華浩成立於2025年，總部設於中國香港，是一間專注於智能產品服務嘅國際貿易企業。現時，公司已建立涵蓋智能手機、平板電腦、筆記本電腦、智能手錶／手環、智能眼鏡等全品類產品佈局，業務覆蓋多個國家及地區，具備完善嘅全球化產品服務能力。", "　　展望未來，華浩將持續聚焦智能產品領域，不斷提升企業服務實力，致力為全球客戶提供更優質、更高效嘅服務，創造更大嘅價值。"],
      features: ["專業團隊", "全球網絡", "品質保證"],
    },
    // timeline: {
    //   items: [
    //     { year: "2010", title: "揚帆起航", desc: "公司在上海成立，專注國際貿易服務" },
    //     { year: "2013", title: "拓展版圖", desc: "業務擴展至東南亞及歐洲市場" },
    //     { year: "2016", title: "數字賦能", desc: "引入智能供應鏈管理系統" },
    //     { year: "2020", title: "全球佈局", desc: "業務覆蓋全球68個國家和地區" },
    //     { year: "2025", title: "智慧未來", desc: "打造AI驅動的智慧貿易平台" },
    //   ],
    // },
    services: {
      title: "一站式國際貿易服務",
      items: [
        { icon: "el-icon-shopping-cart-2", title: "全球採購", desc: "整合全球優質供應商，提供一站式採購服務" },
        { icon: "el-icon-connection", title: "供應鏈管理", desc: "端到端供應鏈解決方案，全程可視化管理" },
        { icon: "el-icon-suitcase", title: "貿易履約", desc: "全流程貿易執行與交付協調，確保訂單順利完成" },
        { icon: "el-icon-wallet", title: "貿易融資", desc: "靈活的融資方案，助力企業資金周轉" },
        { icon: "el-icon-data-analysis", title: "市場分析", desc: "深度市場研究，把握商業機會" },
        { icon: "el-icon-document", title: "商務諮詢", desc: "專業貿易諮詢，規避風險合規經營" },
      ],
    },
    values: {
      title: "我們的承諾",
      intro: "秉承專業、誠信、創新的理念，為客戶提供卓越的服務體驗",
      items: [
        { title: "誠信為本", desc: "以誠信贏得信任，建立長期合作關係" },
        { title: "專業高效", desc: "專業團隊提供高效服務，創造最大價值" },
        { title: "持續創新", desc: "不斷創新服務模式，引領行業發展" },
        { title: "合作共贏", desc: "與夥伴共同成長，實現互利共贏" },
      ],
    },
    cta: {
      title: "開啟全球貿易新篇章",
      subtitle: "期待與您攜手合作，共創輝煌未來",
      button: "聯繫我們",
    },
  },
  partners: {
    title: "服務客戶",
    subtitle: "我們與全球知名企業建立了長期穩定的合作關係，共同為客戶提供優質的產品和服務",
  },
  strategy: {
    title: "發展戰略",
    subtitle: "",
    description: "面向未來發展，以客戶為中心，不斷創新商業模式。致力於打造全球化產業平台，深化與世界各地的合作。通過數字化轉型，提升供應鏈效率和服務質量，為客戶創造更大價值，實現可持續發展。",
  },
  footer: {
    contact: "聯繫方式",
    quickLinks: "快速鏈接",
    company: "公司",
    companyName: "華浩國際（香港）有限公司",
    slogan1: "創新引領，科技賦能",
    slogan2: "品質生活，普惠全球",
    motto: "Empower global customers with innovation and technology",
    address: "1325 13/F Golden Industrial Bldg, Kwai Fong, NT, Hong Kong",
    phone: "+852 53031585(HK)",
    email: "+852 3709 7014",
    copyright: "© Copyright 2025. Huahao International (Hong Kong) Co., Limited",
    icp: "ICP備案號",
  },
  messages: {
    contactSuccess: "感謝您的關注，我們將盡快與您聯繫！",
    learnMore: "感謝您的關注！",
    inquireNow: "感謝您的諮詢，我們的工作人員會盡快與您取得聯繫！",
  },

  // 人工智能軟件頁面
  aiSoftware: {
    pageTitle: "人工智能軟件",
    pageIntro: "基於前沿人工智能技術，提供覆蓋視覺、語音、算法、應用的全棧AI軟件解決方案",
    categories: [
      {
        title: "視覺AI",
        items: [
          { name: "計算機視覺", desc: "高精度圖像識別與場景理解" },
          { name: "人臉識別", desc: "毫秒級人臉檢測與身份驗證" },
          { name: "OCR文字識別", desc: "支持多語言的智能文字提取" },
        ],
      },
      {
        title: "語音AI",
        items: [
          { name: "語音識別", desc: "實時語音轉文字，支持多種方言" },
          { name: "語音合成", desc: "自然流暢的TTS語音輸出" },
          { name: "智能語音助手", desc: "多輪對話與智能語音交互" },
        ],
      },
      {
        title: "算法平台",
        items: [
          { name: "機器學習平台", desc: "一站式模型訓練與部署平台" },
          { name: "深度學習框架", desc: "高性能神經網絡計算引擎" },
          { name: "AI算法服務", desc: "開箱即用的算法API服務" },
        ],
      },
      {
        title: "智能應用",
        items: [
          { name: "智能推薦系統", desc: "精準的個性化內容推薦引擎" },
          { name: "自然語言處理", desc: "文本分析與智能語義理解" },
          { name: "智能客服系統", desc: "7x24小時AI客服解決方案" },
        ],
      },
    ],
  },

  // 智能機器人頁面
  smartRobot: {
    pageTitle: "智能機器人",
    pageIntro: "華浩國際深耕智能機器人領域，憑藉先進的AI算法、精密傳感技術和智能控制系統，為客戶提供覆蓋服務、教育、家庭清潔等多場景的機器人產品解決方案，以創新科技賦能智慧生活，為消費者打造更便捷、更智能的未來生活方式。",
    sections: [
      {
        title: "服務機器人",
        paragraphs: ["結合先進的人工智能技術、計算機視覺、自然語言處理和自主導航系統，為客戶提供智能交互、精準識別、靈活移動的服務機器人整體解決方案。產品廣泛應用於商業接待、醫療輔助、酒店服務等多個場景。", "通過深度學習算法和多傳感器融合技術，實現人機自然交互、環境感知與避障、任務自主執行等核心功能，為各行業提供高效、可靠的智能服務體驗。"],
      },
      {
        title: "教育機器人",
        paragraphs: ["專注於STEAM教育和編程教學領域，融合機器人技術、編程教育和人工智能，為青少年提供寓教於樂的智能教育產品。支持圖形化編程、Python編程等多種編程方式，培養學生的創新思維和動手能力。", "配備豐富的傳感器模塊和執行器件，支持項目式學習和競賽活動，幫助學生在實踐中掌握機器人技術、編程邏輯和AI應用，激發對科技的興趣和探索精神。"],
      },
      {
        title: "掃地機器人",
        paragraphs: ["採用激光雷達SLAM技術和視覺導航系統，實現精準建圖、智能規劃清掃路徑和高效清潔覆蓋。結合強勁吸力、智能濕拖系統和自動集塵功能，為用戶提供全方位的家庭清潔解決方案。", "通過AI算法實現障礙物識別與智能避障，支持多樓層地圖管理、定時預約、遠程控制等智能功能。低噪音設計和長續航能力，讓家庭清潔更加輕鬆便捷，釋放用戶更多時間享受生活。"],
      },
    ],
  },

  // 技術開發與服務頁面
  techService: {
    pageTitle: "技術開發與服務",
    pageIntro: "提供企業級軟件系統解決方案，助力企業數字化轉型與業務增長",
    systems: [
      {
        title: "CRM系統",
        subtitle: "Customer Relationship Management",
        features: ["客戶全生命周期管理", "銷售漏斗可視化分析", "智能商機跟進提醒", "多渠道客戶數據整合", "自動化營銷工作流", "數據報表與決策支持"],
      },
      {
        title: "SCRM系統",
        subtitle: "Social Customer Relationship Management",
        features: ["社交媒體客戶管理", "企業微信深度集成", "私域流量運營工具", "社群自動化管理", "客戶標籤精準畫像", "社交互動數據分析"],
      },
      {
        title: "SAAS系統",
        subtitle: "Software as a Service",
        features: ["雲端部署開箱即用", "多租戶架構設計", "彈性擴展按需付費", "數據安全與備份", "跨平台無縫協作", "持續更新與維護"],
      },
    ],
  },

  // 智能穿戴頁面
  smartWearable: {
    pageTitle: "智能穿戴",
    pageIntro: "華浩以敏銳的市場洞察力，率先切入運動健康領域。分析產業、行業趨勢，在智能手錶、智能手環、TWS耳機等產品上不斷超越，運用卓越的技術創新、精密製造能力為客戶提供超出預期的整體解決方案，為消費者打造更為豐富的數字化健康生活方式。",
    sections: [
      {
        title: "智能手錶",
        paragraphs: ["具有行業領先的全領域軟件開發能力，多種業界主流運動手錶、通話手錶的系統開發和全平台複雜架構設計經驗，擁有位居行業前列的器件高密度佈局技術，極致利用產品空間，成熟的5ATM防水設計/測試貫穿生產全階段。", "產品全球化定制，柔性製造交付能力，充分滿足客戶需求。"],
      },
      {
        title: "智能手環",
        paragraphs: ["在多重功耗優化、運動健康設計開發與算法調試、多平台研發上具有豐富的經驗和技術。", "通過長續航、低功耗設計、小型化設計、防水油設計、天線方案系統設計，柔性製造交付能力，有效滿足客戶的多樣化需求。"],
      },
      {
        title: "TWS耳機",
        paragraphs: ["擁有行業領先的聲學設計、調試、測試及音頻算法能力，採用智能降噪、高清音頻傳輸等先進技術，即使在嘈雜環境下，仍可帶來高品質的音樂享受、呈現純粹的高保真音質。", "結合天線、低功耗、防水等豐富的整機設計經驗，主流Android客戶的服務經驗，為客戶提供從入門級到旗艦級的聲學整體解決方案。"],
      },
    ],
  },

  // 家庭終端頁面
  homeTerminal: {
    pageTitle: "家庭終端",
    pageIntro: "為家庭終端產品提供從市場調研、產品概念、ID設計到研發、生產製造的一體化解決方案，在VR & AR、智能音箱、智能門鎖、TV等產品領域，為客戶提供高品質、高性價比的整體解決方案，為消費者打造更輕鬆、更有溫度的沉浸式超凡體驗。",
    sections: [
      {
        title: "VR & AR",
        paragraphs: ["憑藉自身強大的集成軟硬件設計與精密製造能力，為客戶提供VR&AR一站式系統解決方案，涵蓋光學、聲學、功耗、射頻、天線、堆疊、結構、軟件底層驅動、6DoF算法、眼動算法、面部識別算法等在內的整體設計方案，以及零部件、模具、注塑、校準、組裝、自動化在內的整體製造方案。", "為消費者完美呈現4K 360°影像，帶來更舒適、更具沉浸式的超凡體驗。"],
      },
      {
        title: "智能音箱",
        paragraphs: ["成熟的觸控和高清大屏顯示技術，多麥克陣列設計和降噪技術，高功率大喇叭及腔體一體化設計技術為智能音箱研發和生產提供有效保障。", "多硬件平台和安卓系統的開發經驗也進一步加速產品的開發和交付，加持專業的音頻實驗室和主客觀評價方法和能力，有效滿足客戶的高品質要求和體驗。"],
      },
      {
        title: "智能門鎖",
        paragraphs: ["憑藉多年來在指紋、攝像頭、觸控、屏幕、WIFI及藍牙方面的技術積累、安全和暴力防拆技術、自身強大的工業設計能力以及對鎖芯和鎖體的行業整合力，快速在智能門鎖領域脫穎而出。", "產品覆蓋各價位段，充分滿足客戶的多樣化需求。"],
      },
      {
        title: "TV",
        paragraphs: ["主要從事板卡、電視棒等產品的研發、生產和交付，通過不斷提供革新性的產品及服務，目前已覆蓋TV、Monitor、商用顯示整機等，根據客戶的需求進行客制化產品的開發設計。", "幫助客戶以更優的成本、更快的速度和更高的品質為用戶提供更優質的產品及服務。"],
      },
    ],
  },

  // 個人終端頁面
  personalTerminal: {
    pageTitle: "個人終端",
    pageIntro: "從產品定制到平台能力，華浩國際持續深耕個人終端領域，構建覆蓋多終端形態的智能產品體系，為全球客戶提供從研發到量產的一站式解決方案。",
    sections: [
      {
        title: "智能手機 & 平板電腦",
        paragraphs: ["作為個人終端領域的重要組成部分，華浩在智能手機與平板電腦方向持續推進技術創新與製造能力升級，建立了靈活高效的多區域交付體系。", "圍繞不同客戶的產品定位與市場需求，華浩深入分析終端用戶使用習慣、主流市場趨勢及新技術演進方向，結合性能、成本與可靠性的綜合考量，為客戶打造具備競爭力的高品質終端產品。"],
      },
      {
        title: "筆記本電腦",
        paragraphs: ["憑藉持續的技術投入與智能製造能力建設，華浩在筆記本電腦領域逐步形成了成熟的產品開發與交付體系。", "圍繞輕薄化、高性能與可靠性的核心需求，華浩不斷突破在結構設計、散熱方案與整機集成方面的技術邊界，與客戶協同打造兼顧性能與品質的筆記本電腦產品。"],
      },
    ],
  },

  // 聯繫我們頁面
  contact: {
    pageTitle: "聯繫我們",
    breadcrumb: {
      home: "首頁",
      contact: "聯繫我們",
    },
    form: {
      title: "聯繫我們",
      description: "如有任何問題、商業諮詢或合作機會，請隨時與我們聯繫。我們將以專業的態度盡快為您提供幫助。",
      hongKongOffice: "香港辦公室",
      officeLine: "辦公電話",
      tel: "電話",
      email: "郵箱",
      coordinates: "坐標",
      latLng: "(緯度, 經度)",
    },
    map: {
      baidu: "百度地圖",
      amap: "高德地圖",
      google: "Google Maps",
      copyCoordinates: "複製坐標",
      copySuccess: "坐標已複製到剪貼板:",
      copyFailed: "複製失敗，請手動複製:",
      copyError: "複製失敗，坐標為:",
    },
  },
};
